"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridFragment = void 0;
exports.gridFragment = `
fragment gridFragment on Grid {
  id
  tenantId
  name
  meta {
    key
    value
  }
  isPublished
  rows {
    meta {
      key
      value
    }
    columns {
      layout {
        rowspan
        colspan
      }
      meta {
        key
        value
      }
      itemType
      itemId
      item {
        ...documentPreview
        ...folderPreview
        ...productPreview
      }
    }
  }
}
`;
//# sourceMappingURL=grid.js.map